function cstmchk(v) {
    
      window.value = Number(v);
    
    }



var currentTab = 0;  // Current tab is set to be the first tab (0)
showTab(currentTab);  // Display the current tab
var secwigtype =document.getElementById("secwigtype");
var sechousewig =document.getElementById("sechousewig");



// first Selection
var wigtype =document.getElementById("wigtype");
var housewig = document.getElementById("house-wig");
var premiumwig = document.getElementById("premium-wig");
var topshelfwig = document.getElementById("top-shelf-wig");
var colorofwig = document.getElementById("colorofwig");
var delieverywig = document.getElementById("delieverywig");



function showTab(n) {
    // This function will display the specified tab of the form...
    var x = document.getElementsByClassName("mainboby");
    x[n].style.display = "block";
    //... and fix the Previous/Next buttons:
    if (n == 0) {
      document.getElementById("prevBtn").style.display = "none";
      document.getElementById("secprice").style.display = "none";
    } else {
      document.getElementById("prevBtn").style.display = "inline";
      document.getElementById("secprice").style.display = "inline";
      
    }
    if (n == (x.length - 1)) {
      document.getElementById("prductbtn").style.display = "Block";
      document.getElementById("prevBtn").style.display = "none";
      document.getElementById("nextBtn").style.display = "none";
    } else if(n == 0) {
      document.getElementById("nextBtn").innerHTML = "ALLOW US TO TAKE YOUR ORDER";
    //   document.getElementById("nextBtn").style.textAlign = "center";
    }
    else{
        document.getElementById("nextBtn").innerHTML = "Proceed Next";
    }
    // //... and run a function that will display the correct step indicator:
    // fixStepIndicator(n)
  }





  function nextPrev(n) {
    // This function will figure out which tab to display
    var x = document.getElementsByClassName("mainboby");
    // Exit the function if any field in the current tab is invalid:
    if (n == 1);
    // Hide the current tab;
    x[currentTab].style.display = "none";
    // Increase or decrease the current tab by 1:
    currentTab = currentTab + n;
 if (currentTab == 2) {
        
        if(wigtype.value=="Make a selection"){
            wigtype.style.color="red";
              alert("Please Make a selection");
              currentTab = currentTab - 1;
              x[currentTab].style.display = "block";

            }
            
            else if(wigtype.value=="House"){
              currentTab;
              
              
              
              
            }
            else if(wigtype.value=="Premium"){
               
              currentTab = currentTab + 1 ;
               
    
            
            }
            
            else if(wigtype.value=="TopShelf"){

              document.getElementById("myRange").disabled = true;
                currentTab = currentTab + 2;

            
            }
        }

    else if (currentTab == 3 ) {
        
                if(housewig.value=="0"){
                    housewig.style.color="red";
                      alert("Please select an option");
                      currentTab = currentTab - 1;
                      x[currentTab].style.display = "block";
                    
                    }
                    
              else if (housewig.value=="50") {
                
                addItem('add-to-cart1');
                currentTab = currentTab + 2 ;
              }
      
      		else if (housewig.value=="75") {
              
                addItem('add-to-cart2');
                currentTab = currentTab + 2 ;
              }
      
      		else if (housewig.value=="100") {
              
                addItem('add-to-cart3');
                currentTab = currentTab + 2 ;
              }
  }

  else if (currentTab == 4 ) {
        
          if(premiumwig.value=="0"){
            premiumwig.style.color="red";
                alert("Please select an option");
                currentTab = currentTab - 1;
                x[currentTab].style.display = "block";
              
              }
    
    else if (premiumwig.value=="75") {
                
                addItem('add-to-cartp1');
                currentTab = currentTab + 1 ;
              }
      
      		else if (premiumwig.value=="100") {
              
                addItem('add-to-cartp2');
                currentTab = currentTab + 1 ;
              }
      
      		else if (premiumwig.value=="101") {
              
                addItem('add-to-cartp3');
                currentTab = currentTab + 1 ;
              }
    
    else if (premiumwig.value=="125") {
              
                addItem('add-to-cartp4');
                currentTab = currentTab + 1 ;
              }
              

  }

  else if (currentTab == 5 ) {

    if(topshelfwig.value == "0"){
      topshelfwig.style.color="red";
          alert("Please Select an option");
          currentTab = currentTab - 1;
           x[currentTab].style.display = "block";
          
          
        
        }
        
    else if (topshelfwig.value=="125") {
                
                addItem('add-to-cartp5');
                currentTab;
              }
      
      		else if (topshelfwig.value=="150") {
              
                addItem('add-to-cartp6');
                currentTab;
              }
      
      		else if (topshelfwig.value=="151") {
              
                addItem('add-to-cartp7');
                currentTab;
              }
    
    else if (topshelfwig.value=="175") {
              
                addItem('add-to-cartp8');
                currentTab;
              }
    
    
    
    if (window.value == 25) {
     
      setTimeout(rangeslide0, 1500)
      
      function rangeslide0() {
        addItem('add-to-cartrs1');
      }
      
    }
    
    else if (window.value == 50) {
     
      setTimeout(rangeslide0, 1500)
      
      function rangeslide0() {
        addItem('add-to-cartrs1');
      }
      
      setTimeout(rangeslide, 3000)
      
      function rangeslide() {
        addItem('add-to-cartrs1');
      }
      
    }
    
    else if (window.value == 75) {
     
      setTimeout(rangeslide0, 1500)
      
      function rangeslide0() {
        addItem('add-to-cartrs1');
      }
      
      setTimeout(rangeslide, 3000)
      
      function rangeslide() {
        addItem('add-to-cartrs1');
      }
      
      setTimeout(rangeslide2, 4000)
      
      function rangeslide2() {
        addItem('add-to-cartrs1');
      }
      
    }
    
    else if (window.value == 100) {
     
      setTimeout(rangeslide0, 1500)
      
      function rangeslide0() {
        addItem('add-to-cartrs1');
      }
      
      setTimeout(rangeslide, 2500)
      
      function rangeslide() {
        addItem('add-to-cartrs1');
      }
      
      setTimeout(rangeslide2, 3500)
      
      function rangeslide2() {
        addItem('add-to-cartrs1');
      }
      
      setTimeout(rangeslide3, 4500)
      
      function rangeslide3() {
        addItem('add-to-cartrs1');
      }
      
    }
    
    

    }   

    else if (currentTab == 6 ) {

    if (img1.classList.contains('cstm_amt')) {

      setTimeout(load6, 1000);
        
        function load6 () {
         
          addItem('add-to-cart4');
          
        }

    }
      
      
      if (img2.classList.contains('cstm_amt')) {

      setTimeout(load7, 2000);
        
        function load7 () {
         
          addItem('add-to-cart5');
          
        }

    }
      
      
      if (img3.classList.contains('cstm_amt')) {

      setTimeout(load8, 3000);
        
        function load8 () {
         
          addItem('add-to-cart6');
          
        }

    }
      
      
      if (img4.classList.contains('cstm_amt')) {

      setTimeout(load9, 4000);
        
        function load9 () {
         
          addItem('add-to-cart7');
          
        }

    }
      
      
  
      } 


      else if (currentTab == 7 ) {

        

        if(colorofwig.value == "0" && customwig.value == 'yes'){
          colorofwig.style.color="red";
              alert("Please Select an option");
              currentTab = currentTab - 1;
              x[currentTab].style.display = "block";
              
              
            
            }
        
        else if (colorofwig.value=="15") {
                
                addItem('add-to-cart8');
              }
        
        else if (colorofwig.value=="25") {
                
                addItem('add-to-cart9');
              }
        
        else if (colorofwig.value=="35") {
                
                addItem('add-to-cart10');
              }
        
        
        
        if (window.value == 10) {
     
      setTimeout(rangeslide0, 700)
      
      function rangeslide0() {
        addItem('add-to-cartrs2');
      }
      
    }
    
    else if (window.value == 20) {
     
      setTimeout(rangeslide0, 700)
      
      function rangeslide0() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide, 1400)
      
      function rangeslide() {
        addItem('add-to-cartrs2');
      }
      
    }
    
    else if (window.value == 30) {
     
      setTimeout(rangeslide0, 700)
      
      function rangeslide0() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide, 1400)
      
      function rangeslide() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide2, 2100)
      
      function rangeslide2() {
        addItem('add-to-cartrs2');
      }
      
    }
    
    else if (window.value == 40) {
     
      setTimeout(rangeslide0, 700)
      
      function rangeslide0() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide, 1400)
      
      function rangeslide() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide2, 2100)
      
      function rangeslide2() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide3, 2800)
      
      function rangeslide3() {
        addItem('add-to-cartrs2');
      }
      
    }
        
        
      else if (window.value == 50) {
     
      setTimeout(rangeslide0, 700)
      
      function rangeslide0() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide, 1400)
      
      function rangeslide() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide2, 2100)
      
      function rangeslide2() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide3, 2800)
      
      function rangeslide3() {
        addItem('add-to-cartrs2');
      }
          
      setTimeout(rangeslide4, 3500)
      
      function rangeslide4() {
        addItem('add-to-cartrs2');
      }
      
    }
        
        
      else if (window.value == 60) {
     
      setTimeout(rangeslide0, 700)
      
      function rangeslide0() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide, 1400)
      
      function rangeslide() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide2, 2100)
      
      function rangeslide2() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide3, 2800)
      
      function rangeslide3() {
        addItem('add-to-cartrs2');
      }
          
      setTimeout(rangeslide4, 3500)
      
      function rangeslide4() {
        addItem('add-to-cartrs2');
      }
        
      setTimeout(rangeslide5, 4200)
      
      function rangeslide5() {
        addItem('add-to-cartrs2');
      }  
      
    }
        
        
      else if (window.value == 70) {
     
      setTimeout(rangeslide0, 700)
      
      function rangeslide0() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide, 1400)
      
      function rangeslide() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide2, 2100)
      
      function rangeslide2() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide3, 2800)
      
      function rangeslide3() {
        addItem('add-to-cartrs2');
      }
          
      setTimeout(rangeslide4, 3500)
      
      function rangeslide4() {
        addItem('add-to-cartrs2');
      }
        
      setTimeout(rangeslide5, 4200)
      
      function rangeslide5() {
        addItem('add-to-cartrs2');
      } 
        
      setTimeout(rangeslide6, 5000)
      
      function rangeslide6() {
        addItem('add-to-cartrs2');
      }   
      
    }
        
        
     else if (window.value == 80) {
     
      setTimeout(rangeslide0, 700)
      
      function rangeslide0() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide, 1400)
      
      function rangeslide() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide2, 2100)
      
      function rangeslide2() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide3, 2800)
      
      function rangeslide3() {
        addItem('add-to-cartrs2');
      }
          
      setTimeout(rangeslide4, 3500)
      
      function rangeslide4() {
        addItem('add-to-cartrs2');
      }
        
      setTimeout(rangeslide5, 4200)
      
      function rangeslide5() {
        addItem('add-to-cartrs2');
      } 
        
      setTimeout(rangeslide6, 5000)
      
      function rangeslide6() {
        addItem('add-to-cartrs2');
      }
       
      setTimeout(rangeslide7, 5700)
      
      function rangeslide7() {
        addItem('add-to-cartrs2');
      } 
      
    }
        
        
     else if (window.value == 90) {
     
      setTimeout(rangeslide0, 700)
      
      function rangeslide0() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide, 1400)
      
      function rangeslide() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide2, 2100)
      
      function rangeslide2() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide3, 2800)
      
      function rangeslide3() {
        addItem('add-to-cartrs2');
      }
          
      setTimeout(rangeslide4, 3500)
      
      function rangeslide4() {
        addItem('add-to-cartrs2');
      }
        
      setTimeout(rangeslide5, 4200)
      
      function rangeslide5() {
        addItem('add-to-cartrs2');
      } 
        
      setTimeout(rangeslide6, 5000)
      
      function rangeslide6() {
        addItem('add-to-cartrs2');
      }
       
      setTimeout(rangeslide7, 5700)
      
      function rangeslide7() {
        addItem('add-to-cartrs2');
      }
       
      setTimeout(rangeslide8, 6500)
      
      function rangeslide8() {
        addItem('add-to-cartrs2');
      } 
      
    }
        
        
     else if (window.value == 100) {
     
      setTimeout(rangeslide0, 700)
      
      function rangeslide0() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide, 1400)
      
      function rangeslide() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide2, 2100)
      
      function rangeslide2() {
        addItem('add-to-cartrs2');
      }
      
      setTimeout(rangeslide3, 2800)
      
      function rangeslide3() {
        addItem('add-to-cartrs2');
      }
          
      setTimeout(rangeslide4, 3500)
      
      function rangeslide4() {
        addItem('add-to-cartrs2');
      }
        
      setTimeout(rangeslide5, 4200)
      
      function rangeslide5() {
        addItem('add-to-cartrs2');
      } 
        
      setTimeout(rangeslide6, 5000)
      
      function rangeslide6() {
        addItem('add-to-cartrs2');
      }
       
      setTimeout(rangeslide7, 5700)
      
      function rangeslide7() {
        addItem('add-to-cartrs2');
      }
       
      setTimeout(rangeslide8, 6500)
      
      function rangeslide8() {
        addItem('add-to-cartrs2');
      }
       
      setTimeout(rangeslide9, 7200)
      
      function rangeslide9() {
        addItem('add-to-cartrs2');
      } 
      
    }   
        
        
        
  
      } 


    else if (currentTab == 8 ) {

      if (combs.classList.contains('cstm_bmt')) {
		
      setTimeout(load1, 1000);
        
        function load1 () {
         
          addItem('add-to-cart11');
          
        }

    }
      
      if (Ventilated.classList.contains('cstm_bmt')) {

      setTimeout(load5, 6000);
        
        function load5 () {
         
          addItem('add-to-cart12');
          
        }

    }
      
      if (Mesh.classList.contains('cstm_bmt')) {

      setTimeout(load2, 2000);
        
        function load2 () {
         
          addItem('add-to-cart13');
          
        }

    }
      
      if (Dome.classList.contains('cstm_bmt')) {

      setTimeout(load3, 3000);
        
        function load3 () {
         
          addItem('add-to-cart14');
          
        }

    }
      
      if (Satin.classList.contains('cstm_bmt')) {

      setTimeout(load4, 5000);
        
        function load4 () {
         
          addItem('add-to-cart15');
          
        }

    }
            

             
  
      } 

      else if (currentTab == 9 ) {

        if(shipping.checked == false){

          x[currentTab].style.display = "none";
          currentTab = currentTab - n;
          alert("Please select all fields");

        }

        if(delieverywig.value == "0"){

            
            }
            else if (delieverywig.value == "15") {
              
              addItem('add-to-cart16');
  
            } 
  
            else if (delieverywig.value == "30") {
              
              addItem('add-to-cart17');
  
            }
        
        else if (delieverywig.value == "35") {
              
          addItem('add-to-cart18');
  
            }
        
  
      } 


console.log(currentTab);
  // Otherwise, display the correct tab:
// Increase or decrease the current tab by 1:
   
  showTab(currentTab);
    
    document.getElementsByClassName('chotapayo')[0].style.display = 'none';
    
    window.scrollTo(0, 0);
    
  }

        






// Price Increase Function
var sexyNum = 0;
function Price(a){

var dollar = document.getElementById("dollar");
var sechousewig =document.getElementById("sechousewig").style.display;
var secpremium =document.getElementById("secpremium").style.display;
var sectopshelf =document.getElementById("sectopshelf").style.display;

var x = Number(dollar.value);


        if( sectopshelf == "block"){
          document.getElementById("myRange").disabled = false;
        }

        x = x - sexyNum;
      var z = Number(a);

      
      dollar.value = x + z;

      sexyNum = z;
    }


    // Price Increase custom section Function
var sexy2Num = 0;
function Price2(a){

var dollar = document.getElementById("dollar");
var sectopshelf =document.getElementById("sectopshelf").style.display;

var x = Number(dollar.value);


        if( sectopshelf == "block"){
          document.getElementById("myRange").disabled = false;
        }

        x = x - sexy2Num;
      var z = Number(a);

      
      dollar.value = x + z;

      sexy2Num = z;
    }







//rang Bar Price increase Function

var lastNum = 0 ;
function pricerange(a){

  var x = Number(dollar.value);
  

  if(lastNum <= a)  {
   dollar.value = x + 25;
//    console.log(a);
   lastNum = a;
} 
else if(a == 100){
  dollar.value = x + 25;
//   console.log(a + "This is desi part");
  lastNum = 110;
}

else {
  dollar.value = x - 25;
//   console.log(a + "This is else part");
  lastNum = a;
}

}




//rang Bar Price increase Function

var lastNum = 0 ;
function pricerange2(a){

  var x = Number(dollar.value);
  

  if(lastNum <= a)  {
   dollar.value = x + 10;
//    console.log(a);
   lastNum = a;
} 
else if(a == 100){
  dollar.value = x + 10;
//   console.log(a + "This is desi part");
  lastNum = 110;
}

else {
  dollar.value = x - 10;
//   console.log(a + "This is else part");
  lastNum = a;
}

}



//Images Section Price Increase Function

var img1 = document.getElementsByClassName("img")[0];

var img2 = document.getElementsByClassName("img")[1];
      
var img3 = document.getElementsByClassName("img")[2];

var img4 = document.getElementsByClassName("img")[3];


function toggle() {


img1.classList.toggle("cstm_amt");

if (img1.classList.contains('cstm_amt')) {

  dollar.value = Number(dollar.value) + 15;

} else {

  dollar.value = Number(dollar.value) - 15;

}


}


function toggle2() {

  
  img2.classList.toggle("cstm_amt");
  
  if (img2.classList.contains('cstm_amt')) {
  
    dollar.value = Number(dollar.value) + 30;
  
  } else {
  
    dollar.value = Number(dollar.value) - 30;
  
  }
  
  
  }


  function toggle3() {

    
    img3.classList.toggle("cstm_amt");
    
    if (img3.classList.contains('cstm_amt')) {
    
      dollar.value = Number(dollar.value) + 50;
    
    } else {
    
      dollar.value = Number(dollar.value) - 50;
    
    }
    
    
    }


    function toggle4() {

      
      img4.classList.toggle("cstm_amt");
      
      if (img4.classList.contains('cstm_amt')) {
      
        dollar.value = Number(dollar.value) + 60;
      
      } else {
      
        dollar.value = Number(dollar.value) - 60;
      
      }
      
      
      }

      function notoggle(){
        var img4 = document.getElementsByClassName("img")[3];
        var img3 = document.getElementsByClassName("img")[2];
        var img2 = document.getElementsByClassName("img")[1];
        var img1 = document.getElementsByClassName("img")[0];

        if(img4.classList.contains('cstm_amt')){
          img4.classList.remove('cstm_amt');
          dollar.value = Number(dollar.value) - 60;

        }
        if(img3.classList.contains('cstm_amt')){
          img3.classList.remove('cstm_amt');
          dollar.value = Number(dollar.value) - 50;

        }
        if(img2.classList.contains('cstm_amt')){
          img2.classList.remove('cstm_amt');
          dollar.value = Number(dollar.value) - 30;
        }
        if(img1.classList.contains('cstm_amt')){
          img1.classList.remove('cstm_amt');
          dollar.value = Number(dollar.value) - 15;
        }


      }


      // Custom WIG SECTION FUNCTION
      var customwig = document.getElementById("customwig");
      var color = document.getElementsByClassName("color");
      function getvalue(value){
       
      if(value == "yes"){
        color[0].style.display = "block";
        color[1].style.display = "block";
      }

      else if(value == "no"){
        color[0].style.display = "none";
        color[1].style.display = "none";
      }


      }




// Custom pices switch SECTION FUNCTION
      function sliderswitch0(a){
    combs.classList.toggle("cstm_bmt");

      }

      var combs = document.getElementsByClassName("inputslide")[0];
      var Ventilated  = document.getElementsByClassName("inputslide")[1];
      var Mesh  = document.getElementsByClassName("inputslide")[2];
      var Dome = document.getElementsByClassName("inputslide")[3];
      var Satin = document.getElementsByClassName("inputslide")[4];
      var shipping  = document.getElementsByClassName("inputslide")[5];
      var email  = document.getElementsByClassName("inputslide")[6];



      function sliderswitch1(a){
    
        Ventilated.classList.toggle("cstm_bmt");
        var z = Number(a);
        if(Ventilated.classList.contains('cstm_bmt')){

          dollar.value = Number(dollar.value) + z ;

        }
        else{
          dollar.value = Number(dollar.value) - z ;

        }

      }
      function sliderswitch2(a){
    
        Mesh.classList.toggle("cstm_bmt");
        var z = Number(a);
        if(Mesh.classList.contains('cstm_bmt')){

          dollar.value = Number(dollar.value) + z ;

        }
        else{
          dollar.value = Number(dollar.value) - z ;

        }

      }function sliderswitch3(a){
    
        Dome.classList.toggle("cstm_bmt");
        var z = Number(a);
        if(Dome.classList.contains('cstm_bmt')){

          dollar.value = Number(dollar.value) + z ;

        }
        else{
          dollar.value = Number(dollar.value) - z ;

        }

      }function sliderswitch4(a){
    
        Satin.classList.toggle("cstm_bmt");
        var z = Number(a);
        if(Satin.classList.contains('cstm_bmt')){

          dollar.value = Number(dollar.value) + z ;

        }
        else{
          dollar.value = Number(dollar.value) - z ;

        }

      }




      // shiping section price increase function
var sexy3Num = 0;
      function Price3(a){

        var dollar = document.getElementById("dollar");
        
        var x = Number(dollar.value);
        
                x = x - sexy3Num;
              var z = Number(a);
        
              
              dollar.value = x + z;
        
              sexy3Num = z;
            }



            ///LAST BUTTON
            function abc(){

              window.open("https://byob-custom-wig-bar.myshopify.com/pages/wig-customization-fields","_self");
              
              
            }


			function abc2(){
              
            //  AJAX to claer cart items
              
              $.ajax({
                  type: "POST",
                  url: '/cart/clear.js',
                  success: function(){
                    console.log('I cleared the cart!');
                  },
                  dataType: 'json'
                });
              
					window.location.reload(); 
              window.scrollTo(0, 0);
              
              
            }
            







// AJAX Functions


function addItem(form_id) {
   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $('#'+form_id).serialize(),
      success: addToCartOk,
      error: addToCartFail
    });
}
    
    
    function addToCartOk(product) { 
   console.log("Product added to the cart successfully");
}
    
    function addToCartFail(obj, status) { 
   alert("Product failed please try again from begining");
}


	